import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const gladly = defineConnector({
  identifier: "gladly",
  name: "Gladly",
  tagLine: "People-centered customer service",
  logo,
  protocol: "http",
  tags: ["communication", "productivity"],
  defaultUrlPattern: () => "https://.*\\.gladly\\.(com|qa)/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.email,
      password: app.secret.apiToken,
    }),
  steps: [
    {
      title: "Create a Gladly API token",
      items: [
        {
          kind: "markdown",
          content:
            "Give a Gladly user the API User permission, then open **More settings > API Tokens** and create a token for that user.",
        },
      ],
    },
    {
      title: "Enter your Gladly credentials",
      items: [
        {
          kind: "hostname",
          label: "Gladly domain",
          placeholder: "yourorg.gladly.com",
          required: true,
          target: { kind: "configuration", field: "domain" },
          helperText:
            "Your Gladly organization domain. Sandbox environments usually end in gladly.qa.",
        },
        {
          kind: "input",
          label: "Agent email address",
          required: true,
          target: { kind: "configuration", field: "email" },
          helperText:
            "The email address for the Gladly user that owns the API token.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v1/organization`,
  },
  publicEnvVars: ({ domain }) => ({
    GLADLY_URL: domain ? `https://${domain}` : "",
  }),
});
